import { LucideArrowRight } from 'lucide-react';

import { cn } from '../../../lib/stylingUtils';
import { Row } from '../../ui';

type StatusTransitionProps = {
  previousStatus: string;
  newStatus: string;
  className?: string;
};

export const StatusTransition = ({
  previousStatus,
  newStatus,
  className,
}: StatusTransitionProps) => (
  <Row
    className={cn(
      '@StatusTransition',
      'items-center gap-3 rounded-md bg-neutral/5 p-3',
      className,
    )}
    gap3
    yCenter
  >
    <span className="rounded bg-neutral/10 px-2 py-1 text-sm font-medium">
      {previousStatus}
    </span>
    <LucideArrowRight size={16} className="text-neutral/40" />
    <span className="rounded bg-primary/10 px-2 py-1 text-sm font-medium text-primary">
      {newStatus}
    </span>
  </Row>
);
